// note - we have the 'html-entities' package installed, so we could just use that instead
export function hexHtmlToString(str: string) {
    const REG_HEX = /&#x([a-fA-F0-9]+);/g;
    return str.replace(REG_HEX, function (match, grp) {
        const num = parseInt(grp as string, 16);
        return String.fromCharCode(num);
    });
}
